// extracted by mini-css-extract-plugin
export default {"collapsibleBar":"CollapsibleBar_collapsibleBar__vuNj+","bar":"CollapsibleBar_bar__iBi4B","expanded":"CollapsibleBar_expanded__cgSip","collapse":"CollapsibleBar_collapse__HDIsg"};